import { ApiService } from 'services/api.service';
import { CheckoutService } from 'services/checkout.service';
import { createStripeTokenMetadata } from 'services/creditCard.service';

import { SaveAndCancel } from 'components/saveAndCancel/saveAndCancel';
import { CreditCardForm } from 'components/creditCardForm/creditCardForm';
import { AddressForm } from 'components/addressForm/addressForm';
import { stripeElementCardStyle } from 'components/stripeElementsForm/stripeElementsForm';

import { DisplayBillingAddress } from '../displayBillingAddress/displayBillingAddress';
import template from './addPaymentMethod.html';
import './addPaymentMethod.scss';

export const AddPaymentMethod = angular
    .module('checkout.components.editAccountPayment.addPaymentMethod', [
        ApiService,
        CheckoutService,
        SaveAndCancel,
        CreditCardForm,
        AddressForm,
        DisplayBillingAddress
    ]).component('addPaymentMethod', {
        template,
        bindings: {
            onCancelClicked: '&',
            onPaymentMethodSaved: '<',
            initialShippingAddress: '<',
            stripe: '<'
        },
        controller: class AddPaymentMethodCtrl {
            constructor(apiService, checkoutService) {
                this.apiService = apiService;
                this.checkoutService = checkoutService;
                this.showAddressForm = true;
                this.onStripeElementsCardChange = this.onStripeElementsCardChange.bind(this);
            }

            $onInit() {
                if (this.initialShippingAddress) {
                    this.showAddressForm = false;
                    this.billingAddressModel = angular.copy(this.initialShippingAddress);
                    this.billingAddressModel.name =
                        `${this.initialShippingAddress.firstName} ${this.initialShippingAddress.lastName}`;

                    this.paymentMethodForDisplay = {
                        name: this.billingAddressModel.name,
                        address: {
                            line1: this.billingAddressModel.address1,
                            line2: this.billingAddressModel.address2,
                            city: this.billingAddressModel.city,
                            state: this.billingAddressModel.state,
                            zip: this.billingAddressModel.postalCode,
                            country: this.billingAddressModel.country
                        }
                    };
                }

                this.stripeElements = this.stripe.elements();
                this.stripeElementsCard = this.stripeElements.create('card', {
                    style: stripeElementCardStyle,
                    hidePostalCode: true
                });
            }

            onChangeBillingAddressClicked() {
                this.showAddressForm = true;
            }

            onSaveClicked() {
                if (this.addPaymentMethodForm.$invalid || this.stripeElementsError) {
                    this.checkoutService.forceFormValidation(this.addPaymentMethodForm['$ctrl.addressForm']);
                    return;
                }

                this.isSaving = true;

                this.stripe.createToken(this.stripeElementsCard, createStripeTokenMetadata(this.billingAddressModel))
                    .then(({ token }) => {
                        return this.apiService.account.paymentMethod.add(token.id, this.setAsDefault)
                            .then((paymentMethod) => {
                                return this.onPaymentMethodSaved(paymentMethod);
                            });
                    }).finally(() => {
                        this.isSaving = false;
                    });
            }

            onStripeElementsCardChange({ error }) {
                this.stripeElementsError = error;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/editAccountPayment/addPaymentMethod/addPaymentMethod.js